export const ADMIN_SETTING_LOAD = 'ADMIN_SETTING_LOAD'
